import React from "react";
import { Header, Footer, Page } from "@/components/Shell";
import { Link } from "react-router-dom";

const Bullet = ({ children }) => (
  <li className="flex gap-4 text-text-2 leading-relaxed text-[17px]">
    <span className="text-bronze mt-2">·</span>
    <span>{children}</span>
  </li>
);

export default function Method() {
  return (
    <Page tone="ivory">
      <Header variant="ivory" />
      <section className="max-w-4xl mx-auto px-6 md:px-10 pt-20 pb-16" data-testid="method-page">
        <div className="overline mb-6">La Méthode MB™</div>
        <h1 className="font-display text-[44px] md:text-[54px] leading-[1.08] text-ink">La démarche derrière Le Révélateur™</h1>
        <div className="architect-line my-12 max-w-md" />
        <div className="space-y-5 text-[19px] leading-relaxed text-text-2">
          <p>La Méthode MB™ est une façon structurée de lire une entreprise.</p>
          <p>Elle ne regarde pas seulement ce que l'entreprise vend. Elle regarde ce qu'elle dit, ce qu'elle construit et ce qu'elle permet.</p>
          <p className="text-ink">Cette lecture aide à repérer :</p>
          <ul className="space-y-3 mt-4">
            <Bullet>les forces déjà présentes ;</Bullet>
            <Bullet>les messages qui manquent de clarté ;</Bullet>
            <Bullet>les priorités dispersées ;</Bullet>
            <Bullet>les décisions reportées ;</Bullet>
            <Bullet>les dépendances fragiles ;</Bullet>
            <Bullet>les occasions de mieux aligner l'entreprise.</Bullet>
          </ul>
        </div>

        <div className="mt-16 card-lux bg-stone border-none">
          <div className="overline">Doctrine</div>
          <p className="font-display italic text-[26px] md:text-[30px] leading-snug text-ink mt-4">
            Le but n'est pas de juger l'entreprise. Le but est de révéler ce qui mérite d'être compris.
          </p>
        </div>

        <div className="mt-14">
          <Link to="/commencer" className="btn-primary" data-testid="method-cta">Commencer ma lecture stratégique — 49 $</Link>
        </div>
      </section>
      <Footer />
    </Page>
  );
}
